// This library contains an agnostic video player constructor function that allows
// youtube and vimeo players to be controlled with a unified (but minimalistic) API,
// and helpers that can be used to facilitate the conversion of an anchor tag
// that links to a youtube or vimeo video to embed HTML,
// a video type string (youtube | vimeo), and / or a thumbnail.

var JdaVideoTools = {
	SourceAgnosticPlayer: function(data) {

        var scope = this;
		var lastState = null;
		var nativePlayer;
		var htmlId = data.videoData.$iframeElem.attr('id');
        var numericHtmlId = parseInt(htmlId.replace(/^\D+/g, ''));
		var isPlaying = false;

        if (data.videoData.videoType == 'youtube') {
            var videoId = data.videoData.$iframeElem.closest('.jda-bespoke-embed-wrap').data('video-id');
            nativePlayer = new YT.Player(htmlId, {
                videoId: videoId,
                playerVars: {
                    width: 100,
                    height: 100,
                    origin: app.helpers.funcs.baseUrl(),
                    enablejsapi: 1,
                    origin: document.domain,
                    rel: 0
                },
                events: {
					onStateChange: function(e) {
						if (e.data == YT.PlayerState.PLAYING) {
                            if (typeof data.eventData.onPlay == 'function') {
                                data.eventData.onPlay();
                                JdaVideoTools.embedManager.pauseAll(numericHtmlId);
                            }
						} else if (e.data == YT.PlayerState.PAUSED) {
						    if (typeof data.eventData.onPause == 'function') {
						        data.eventData.onPause({
						            ended: false
						        });
						    }
						} else if (e.data == YT.PlayerState.ENDED) {
						    if (typeof data.eventData.onPause == 'function') {
						        data.eventData.onPause({
						            ended: true
						        });
						    }
						} else if (e.data == YT.PlayerState.BUFFERING) {
							var duringPlayback = (scope.lastState == YT.PlayerState.PLAYING) ? true : false;
							if (typeof data.eventData.onBuffering == 'function') data.eventData.onBuffering(duringPlayback);
						}
						scope.lastState = e.data;
                    }
                }
            });
		} else if (data.videoData.videoType == 'vimeo') {
		    if (typeof Vimeo == 'undefined') return;
			nativePlayer = new Vimeo.Player(data.videoData.$iframeElem[0]);
			var onPause = function (ended) {
                if (typeof data.eventData.onPause == 'function') {
                    return data.eventData.onPause({
                        ended: ended
                    });
                }
			}
			nativePlayer.on('play', function () {
			    data.eventData.onPlay();
                JdaVideoTools.embedManager.pauseAll(numericHtmlId);
			});
			nativePlayer.on('pause', function () {
			    return onPause(false);
			});
			nativePlayer.on('ended', function () {
			    return onPause(true);
			})
			//nativePlayer.on('ended', function () {
			    //nativePlayer.setCurrentTime(1); // todo: why is this not working?
			    // data.eventData.onEnd();
			//});
		    // We cannot reset the vimeo player with setCurrentTime once it has ended,
		    // but we can do so while it is playing. Therefore, emulate it by adding a timeupdate
		    // event listener. While the video is playing, this gets called every .25 seconds approx.
            // When we are very near the end of the video, rewind, pause, then call onEnd function.
			nativePlayer.on('timeupdate', function (nativePlayerData) {
			    var endPadding = 0.5;
			    if (nativePlayerData.seconds > nativePlayerData.duration - endPadding) {
			        nativePlayer.setCurrentTime(1);
			        nativePlayer.pause();
			        return onPause(true);
			    }
			});
		} else {
			throw 'The video must be either a youtube or vimeo embed.';
		}

		var getState = function () {
		    var nativeState;
		    try {
		        nativeState = nativePlayer.getPlayerState();
		    } catch (e) {
		        return;
		    }
		    var outputState = 'paused';
		    if (data.videoData.videoType == 'youtube') {
		        if (nativeState === YT.PlayerState.ENDED) outputState = 'ended';
		        if (nativeState === YT.PlayerState.PLAYING) outputState = 'playing';
		        if (nativeState === YT.PlayerState.PAUSED) outputState = 'paused';
		        if (nativeState === YT.PlayerState.BUFFERING) outputState = 'buffering';
		        if (nativeState === YT.PlayerState.QUED) outputState = 'qued';
		    } else if (data.videoData.videoType == 'vimeo') {
		        if (isPlaying) {
		            return 'playing';
		        } else {
		            return 'paused';
		        }
		    } else {
		        throw 'The video must be either a youtube or vimeo embed.';
		    }
		    return outputState;
		};

        var play = function () {
            JdaVideoTools.embedManager.pauseAll(numericHtmlId);
		    isPlaying = true;
            if (data.videoData.videoType == 'youtube') {
                callPlayer(htmlId, 'playVideo');
		    } else if (data.videoData.videoType == 'vimeo') {
		        nativePlayer.play();
		    } else {
		        throw 'The video must be either a youtube or vimeo embed.';
		    }
		};

        var pause = function () {
            if (isPlaying) {
                isPlaying = false;
                if (data.videoData.videoType == 'youtube') {
                    callPlayer(htmlId, 'pauseVideo');
                } else if (data.videoData.videoType == 'vimeo') {
                    if (typeof nativePlayer.pause == 'function') nativePlayer.pause();
                } else {
                    throw 'The video must be either a youtube or vimeo embed.';
                }
            }
		};

		var getHeightRatio = function() {
			var w = 16;
			var h = 9;
			return h / w;
		};

		return {
			play: play,
            pause: pause,
            getState: getState,
			getHeightRatio: getHeightRatio,
			nativePlayer: nativePlayer
		};

	},
    embedManager: {
        embeds: [],
        push: function (embed) {
            this.embeds.push(embed);
        },
        pauseAll: function (exceptHtmlId) {
            exceptHtmlId = typeof exceptHtmlId !== 'undefined' ? exceptHtmlId : false;
            this.embeds.forEach(function (embed) {
                var thisHtmlId = embed.getHtmlId();
                var idsDontMatch = (exceptHtmlId === false || ((exceptHtmlId !== false) && exceptHtmlId != thisHtmlId));
                if (embed && embed.player && idsDontMatch) {
                    embed.player.pause();
                }
            });
        },
    },
	embedHelper: {
	    EmbedHelperError: function(errorId, message) {
	        this.errorId = errorId;
	        this.message = message;
	    },
		generateVideoIdx: function(videoId) {
			var n = 0;
			var maxLoops = 50;
			while ($('#' + videoId + '_' + n).length > 0) {
				if (n > maxLoops) throw 'Max loops hit.';
				n++;
			}
			return videoId + '_' + n;
		},
		discernTypeAndId: function (href) {
			var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
			var match = href.match(regExp);
			if (match && match[7].length == 11) {
				return {
					type: 'youtube',
					id: match[7]
				};
			} else {
				var regExp = /(http|https):\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
				var match = href.match(regExp);
				if (match) {
					return {
						type: 'vimeo',
						id: match[3]
					};
				} else {
					throw new JdaVideoTools.embedHelper.EmbedHelperError('DISCERN_TYPE_AND_ID_ERROR', 'Could not read type or ID from URL provided. It must be a youtube or vimeo URL.');
				}
			}
		},

        discernThumb: function ($elem, videoType, videoId, callback, allowApi) {
            if (videoType == 'youtube') {

                var fallbackData = {
                    thumbUrl: 'https://img.youtube.com/vi/' + videoId + '/sddefault.jpg',
                    title: '',
                    descr: ''
                };

                var fallbackDataArray = Object.keys(fallbackData).map(function (key) { return fallbackData[key]; });

                if (!allowApi) {

                    $elem.trigger(EVENT_NAME__JDA_BESPOKE_EMBED__THUMBNAIL_FOUND, fallbackData);
                    callback.apply(this, fallbackDataArray);
                    return;

                }

		        var youtubeApiKey = app.data.get('config.youtubeApiKey');
		        var url = 'https://www.googleapis.com/youtube/v3/videos?id=' + videoId + '&key=' + youtubeApiKey + '&part=snippet';
		        $.ajax({
		            url: url,
		            dataType: 'json',
		            success: function (data, status) {
                        var thumbUrl = data.items[0].snippet.thumbnails.default.url;
                        if (app.helpers.funcs.arrayGet(data, 'items.0.snippet.thumbnails.high.url')) {
                            thumbUrl = data.items[0].snippet.thumbnails.high.url;
                        }
                        if (app.helpers.funcs.arrayGet(data, 'items.0.snippet.thumbnails.maxres.url')) {
                            thumbUrl = data.items[0].snippet.thumbnails.maxres.url;
                        }
		                var outputData = {
		                    thumbUrl: thumbUrl,
		                    title: data.items[0].snippet.title,
		                    descr: data.items[0].snippet.description
		                };
		                var outputDataArray = Object.keys(outputData).map(function (key) { return outputData[key]; });
		                $elem.trigger(EVENT_NAME__JDA_BESPOKE_EMBED__THUMBNAIL_FOUND, outputData);
		                callback.apply(this, outputDataArray);
                    },
                    error: function (xhr, textStatus, error) {

                        $elem.trigger(EVENT_NAME__JDA_BESPOKE_EMBED__THUMBNAIL_FOUND, fallbackData);
                        callback.apply(this, fallbackDataArray);

                    }
                });

		    } else if (videoType == 'vimeo') {
		        var url = JdaVideoTools.embedHelper.getProtocol() + '://vimeo.com/api/v2/video/' + videoId + '.json';
		        $.ajax({
		            url: url,
		            dataType: 'json',
		            success: function (data, status) {
		                var outputData = {
		                    thumbUrl: data[0].thumbnail_large,
		                    title: data[0].title,
		                    descr: data[0].description
		                };
		                var outputDataArray = Object.keys(outputData).map(function (key) { return outputData[key]; });
		                $elem.trigger(EVENT_NAME__JDA_BESPOKE_EMBED__THUMBNAIL_FOUND, outputData);
		                callback.apply(this, outputDataArray);
		            },
		            error: function() {
		                throw 'Jquery AJAX vimeo thumbnail request error: ' + JSON.stringify(arguments);
		            }
		        });
		    } else {
		        throw 'Only youtube and vimeo are supported.';
		    }
		},

		getEmbedCode: function(videoType, videoId, id, frameTitle) {
			if (videoType == 'youtube') {
				return this.youtubeEmbed(videoId, id, frameTitle);
			} else if (videoType == 'vimeo') {
				return this.vimeoEmbed(videoId, id, frameTitle);
			} else {
				throw 'Only youtube and vimeo are supported.';
			}
		},

		getProtocol: function() {
			var urlArr = window.location.href.split('/');
			var protocol = urlArr[0].indexOf('s') > -1 ? 'https' : 'http';
			return protocol;
		},

        youtubeUrl: function (videoId) {
            var origin = app.helpers.funcs.baseUrl();
			return this.getProtocol() + '://www.youtube.com/embed/' + videoId + '?enablejsapi=1&rel=0&origin=' + origin;
		},

		vimeoUrl: function (videoId) {
			return this.getProtocol() + '://player.vimeo.com/video/' + videoId;
		},

        youtubeEmbed: function (videoId, id, frameTitle) {
            frameTitle = typeof frameTitle !== 'undefined' && frameTitle ? frameTitle : 'Youtube video';
			return '<iframe title="' + frameTitle + '" id="bespokeEmbedIframe-' + id + '" src="' + this.youtubeUrl(videoId) + '" frameborder="0" allowfullscreen></iframe>';
		},

		vimeoEmbed: function(videoId, id) {
            frameTitle = typeof frameTitle !== 'undefined' && frameTitle ? frameTitle : 'Vimeo video';
			return '<iframe title="' + frameTitle + '" id="bespokeEmbedIframe-' + id + '" src="' + this.vimeoUrl(videoId) + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
		}
	}
};

$(document).keyup(function (e) {
    if (e.keyCode == 27) { // esc
        JdaVideoTools.embedManager.pauseAll();
    }
});
